var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinutes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.009,
    height: 12.767,
    viewBox: "0 0 11.009 12.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M500.269,1126.234v-.7a.116.116,0,0,0-.117-.119H494.53a.116.116,0,0,0-.117.119v.7a.116.116,0,0,0,.117.119h5.622A.116.116,0,0,0,500.269,1126.234Zm-5.739,1.293a.115.115,0,0,0-.117.112v.706a.12.12,0,0,0,.117.119h2.693a.12.12,0,0,0,.117-.119v-.706a.115.115,0,0,0-.117-.112Zm5.5,1.693a3.164,3.164,0,1,0,3.162,3.167A3.164,3.164,0,0,0,500.035,1129.22Zm1.574,4.741a2.229,2.229,0,1,1,.651-1.574A2.217,2.217,0,0,1,501.609,1133.961Zm-.271-2.686h-.648a.112.112,0,0,0-.1.044l-.929,1.287-.338-.469a.116.116,0,0,0-.042-.031.058.058,0,0,0-.054-.012h-.645a.115.115,0,0,0-.1.181l1.081,1.5a.118.118,0,0,0,.189,0l1.672-2.317A.114.114,0,0,0,501.338,1131.275Zm-4.7,2.867h-3.4v-10.306h8.2v5.034a.12.12,0,0,0,.117.119h.82a.12.12,0,0,0,.117-.119v-5.621a.47.47,0,0,0-.469-.469h-9.37a.47.47,0,0,0-.468.469v11.48a.47.47,0,0,0,.468.469h3.982a.12.12,0,0,0,.117-.119v-.818A.116.116,0,0,0,496.638,1134.142Z",
    transform: "translate(-492.188 -1122.78)",
    fill: "#899bb5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutes);
export default __webpack_public_path__ + "static/media/minutes.a9bf1b48a5be371b0104f00d6d124ec8.svg";
export { ForwardRef as ReactComponent };